import { useCallback, useState } from 'react'

export function useActionGate() {
  const [hint, setHint] = useState<string | null>(null)

  const clearHint = useCallback(() => setHint(null), [])

  const showHint = useCallback((message: string) => setHint(message), [])

  const gate = useCallback((condition: boolean, message: string, action: () => void) => {
    if (!condition) {
      setHint(message)
      return
    }
    setHint(null)
    action()
  }, [])

  return { hint, clearHint, showHint, gate }
}
